export const activityActionsStyles = {
  deleteDialog: {
    padding: "2rem",
  },
  deleteDialogHeadline: {
    textAlign: "center",
    fontSize: "1.25rem",
    marginBottom: "1rem",
  },
  deleteDialogText: {
    textAlign: "center",
    margin: "1rem 0",
  },
  actionItem: {
    width: "50%",
    textAlign: "right",
  },
  iconButtonContainer: {
    display: "block",
    width: "48px",
    marginLeft: "auto",
    marginRight: 0,
  },
};
